export default "__VITE_ASSET__d7f1c4fa__"